"use client"

import { useProgressBar } from "@/hooks/useGlobalStore"
import { AnimatePresence, motion } from "framer-motion"

export function TopProgressBar() {
  const { progress, isVisible } = useProgressBar()

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="fixed inset-x-0 top-0 z-50 h-1 bg-primary"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        />
      )}
    </AnimatePresence>
  )
}
